/** The API masks a phone as `******1234` unless the role has `see_phone`. Call and WhatsApp need the real number. */
export function isUnmasked(phone: string | null | undefined): phone is string {
  return !!phone && !phone.includes("*") && phone.replace(/\D/g, "").length >= 7;
}
export const telHref = (phone: string) => `tel:+${phone.replace(/\D/g, "")}`;
export const whatsappHref = (phone: string) => `https://wa.me/${phone.replace(/\D/g, "")}`;
